// TODO: possibly need to rename this file to `applianceDrag.utils.ts` and move to `core`
import { DragEvent } from 'react';

import { ApplianceModel, CutoutModel } from '~/core/models';
import { detectBrowser } from '~/core/utils';

const createWrapperElement = () => {
  const wrapper = document.createElement('div');

  wrapper.className = 'drag-image';

  return wrapper;
};

const createCanvasElement = () =>
  document.createElement('canvas') as HTMLCanvasElement;

const calculateHeight = (width: number, zoom: number, imageScaler: number) =>
  width * zoom * imageScaler;

const setCanvasDimensions = (
  canvas: HTMLCanvasElement,
  width: number,
  height: number
) => {
  canvas.width = width;
  canvas.height = height;
};

const drawImageOnCanvas = (
  canvas: HTMLCanvasElement,
  img: HTMLImageElement,
  width: number,
  height: number
) => {
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

  ctx.drawImage(img, 0, 0, width, height);
};

const appendWrapperToBody = (wrapper: HTMLElement) =>
  document.body.appendChild(wrapper);

const setDataTransfer = (e: DragEvent<HTMLImageElement>, data: string) => {
  e.dataTransfer?.setData('text', data);
};

const setDragImage = (
  e: DragEvent<HTMLImageElement>,
  drawnImg: HTMLCanvasElement,
  width: number,
  height: number,
  pointerScaler: number
) => {
  e.dataTransfer?.setDragImage(
    drawnImg,
    width / pointerScaler,
    height / pointerScaler
  );
};

const handleDragEnd = (
  e: DragEvent<HTMLImageElement>,
  wrapper: HTMLElement
) => {
  const img = e.target as HTMLImageElement;

  img.ondragend = () => wrapper.remove();
};

export const applianceDragStart = ({
  e,
  model,
  baseWidth = 1,
}: {
  e: DragEvent<HTMLImageElement>;
  model: CutoutModel | ApplianceModel;
  baseWidth?: number;
}) => {
  const { naturalWidth, naturalHeight } = e.target as HTMLImageElement;
  const wrapper = createWrapperElement();
  const drawnImg = createCanvasElement();

  wrapper.appendChild(drawnImg);

  const aspectRatio = naturalWidth / naturalHeight;
  const [imageScaler, pointerScaler] = { Firefox: [2, 4], Safari: [1, 2] }[
    detectBrowser()
  ] ?? [1, 1];
  const height = calculateHeight(model.width, baseWidth, imageScaler);
  const width = height * aspectRatio;
  const applianceModelString = JSON.stringify(model);

  setCanvasDimensions(drawnImg, width, height);
  drawImageOnCanvas(drawnImg, e.target as HTMLImageElement, width, height);
  appendWrapperToBody(wrapper);
  setDataTransfer(e, applianceModelString);
  setDragImage(e, drawnImg, width, height, pointerScaler);
  handleDragEnd(e, wrapper);
};
